// src/DragAndDrop.js
import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useForm } from "react-hook-form";
import * as yup from "yup";


const DragAndDrop = ({ onFileUpload, uploadedFile, sheetUrl }) => {



  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        onFileUpload(file);
      }
    },
    [onFileUpload]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div>
      <div className="mt-5">
        <label className="mt-5" htmlFor="file">
          Import File
        </label>
        <div
          {...getRootProps()}
          className={` border-dashed border-2 border-green-500 p-[50px] mb-[50px] mt-5 rounded-md`}
        >
          <input name="file" type="file" id="file" value={sheetUrl}
 {...getInputProps()} />

          <p className="text-center text-[12px]">
            <div className="flex justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19.7401 16.9961C21.1518 14.8111 23.217 13.1273 25.6415 12.1847C28.0661 11.242 30.7263 11.0885 33.2431 11.746C35.76 12.4035 38.0052 13.8386 39.6588 15.8467C41.3125 17.8548 42.2902 20.3335 42.4528 22.9298C43.8039 22.8915 45.1493 23.1212 46.4111 23.6057C47.673 24.0902 48.8263 24.8198 49.8046 25.7525C50.783 26.6852 51.5668 27.8025 52.111 29.0398C52.6551 30.2771 52.9487 31.6099 52.9749 32.9613C53.0011 34.3127 52.7594 35.656 52.2636 36.9134C51.7678 38.1709 51.0278 39.3177 50.0864 40.2876C49.145 41.2575 48.0207 42.0313 46.7786 42.5643C45.5365 43.0973 44.2011 43.379 42.8495 43.3931H16.3335C14.4276 43.3913 12.5441 42.9834 10.8082 42.1967C9.07232 41.4101 7.52396 40.2626 6.26622 38.8307C5.00848 37.3988 4.07023 35.7154 3.51395 33.8926C2.95766 32.0698 2.79611 30.1493 3.04004 28.2592C3.28397 26.369 3.9278 24.5526 4.92864 22.9307C5.92948 21.3088 7.26437 19.9188 8.84443 18.8531C10.4245 17.7875 12.2134 17.0707 14.0922 16.7505C15.9709 16.4303 17.8963 16.514 19.7401 16.9961ZM35.2008 29.0944C35.0572 29.2741 34.8796 29.4238 34.6781 29.5348C34.4766 29.6458 34.2552 29.716 34.0266 29.7413C33.7979 29.7667 33.5665 29.7467 33.3456 29.6825C33.1247 29.6184 32.9186 29.5113 32.7391 29.3674L29.7501 26.9734V35.0001C29.7501 35.4642 29.5658 35.9094 29.2376 36.2375C28.9094 36.5657 28.4643 36.7501 28.0001 36.7501C27.536 36.7501 27.0909 36.5657 26.7627 36.2375C26.4345 35.9094 26.2501 35.4642 26.2501 35.0001V26.9734L23.2588 29.3651C23.0792 29.5087 22.8732 29.6154 22.6523 29.6794C22.4315 29.7433 22.2002 29.7631 21.9718 29.7376C21.7433 29.7122 21.5221 29.6419 21.3207 29.531C21.1194 29.42 20.9419 29.2705 20.7983 29.0909C20.6547 28.9114 20.548 28.7053 20.484 28.4845C20.4201 28.2636 20.4003 28.0324 20.4258 27.8039C20.4513 27.5754 20.5215 27.3542 20.6324 27.1529C20.7434 26.9515 20.8929 26.774 21.0725 26.6304L26.9011 21.9708C27.2081 21.7216 27.5907 21.5842 27.9861 21.5811H28.0048C28.4248 21.5811 28.8075 21.7304 29.1085 21.9778L34.9278 26.6304C35.1075 26.774 35.2571 26.9517 35.3681 27.1532C35.4791 27.3546 35.5493 27.576 35.5747 27.8047C35.6 28.0333 35.5801 28.2647 35.5159 28.4856C35.4518 28.7065 35.3447 28.9149 35.2008 29.0944Z"
                  fill="#0176FF"
                />
              </svg>
            </div>

            <p className="text-[#263238] text-[16px]">Upload Image</p>

            {isDragActive
              ? "Drop the file here"
              : "Drag and drop a file here, or click to select a file"}
            {uploadedFile && (
              <p className="font-semibold">{uploadedFile.name}</p>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DragAndDrop;
